import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classes from '../addScripts.module.scss';
import SelectWithSearch from '../../../../_common/Form/Selects/SelectWithSearch/SelectWithSearch';
import api from '../../../../../api/api';
import Chip from '../../../../_common/Chip/Chip';
import InputField from '../../../../_common/Form/TextFields/InputField';
import DOBPicker from '../../../../_common/Form/DatePickers/DOBPicker/DOBPicker';
import utils from '../../../../../utils/utils';

const infoScript = [
  {
    name: 'Name',
    path: 'name',
    optionWidth: '40%',
  },
  {
    name: 'NDC',
    path: 'NDC',
    optionWidth: '20%',
  },
  {
    name: 'Package Size',
    path: 'packageSize',
    optionWidth: '20%',
  },
  {
    name: 'Quantity',
    path: 'quantity',
    optionWidth: '10%',
  },
  {
    name: 'Cost',
    path: 'cost',
    optionWidth: '10%',
  },
];

const infoProduct = [
  {
    name: 'Name',
    path: 'name',
    optionWidth: '15%',
  },
  {
    name: 'NDC',
    path: 'NDC',
    optionWidth: '10%',
  },
  {
    name: 'Package Size',
    path: 'packageSize',
    optionWidth: '15%',
  },
  {
    name: 'Quantity',
    path: 'quantity',
    optionWidth: '15%',
    validation: 'number',
  },
  {
    name: 'Lot',
    path: 'lot',
    optionWidth: '15%',
  },
  {
    name: 'Expiration',
    path: 'expiration',
    optionWidth: '15%',
  },
  {
    name: 'Cost',
    path: 'cost',
    optionWidth: '15%',
    validation: 'currency',
  },
];

const infoAdjust = [
  {
    name: 'Name',
    path: 'name',
    optionWidth: '20%',
  },
  {
    name: 'NDC',
    path: 'NDC',
    optionWidth: '15%',
  },
  {
    name: 'Package Size',
    path: 'packageSize',
    optionWidth: '20%',
  },
  {
    name: 'Quantity',
    path: 'quantity',
    optionWidth: '15%',
    validation: 'currency',
  },
  {
    name: 'Lot',
    path: 'lot',
    optionWidth: '15%',
  },
  {
    name: 'Expiration',
    path: 'expiration',
    optionWidth: '15%',
  },
];

let timeout;

const Medication = ({
  medicationInfo, setMedication, error, product, errors, adjust,
}) => {
  const [medicationsList, setMedicationsList] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [loading, setLoading] = useState(false);

  const viewInput = ['quantity', 'lot', 'cost'];

  const searchMedication = (value) => {
    setSearchValue(value);
    clearTimeout(timeout);

    setMedicationsList([]);

    if (value.trim()) {
      setLoading(true);

      timeout = setTimeout(async () => {
        const { data: { data: { response } } } = await api.searchProduct(value);
        const data = response.filter((r) => !medicationInfo.find(({ id }) => id === r.id));

        setMedicationsList(data);
        setLoading(false);
      }, 400);
    } else {
      setLoading(false);
    }
  };

  const selectMedication = (path, option) => {
    setSearchValue('');
    setMedicationsList([]);

    if (option) {
      setMedication(path, option);
    }
  };

  const info = product ? infoProduct : adjust ? infoAdjust : infoScript;

  const onKeyPress = useCallback((e, validationType, isPaste) => {
    if (validationType === 'currency') {
      utils.keyPressCurrency(e, isPaste);
    } else if (validationType === 'number') {
      utils.keyPressOnlyNumber(e, isPaste, true);
    } else {
      () => {};
    }
  }, []);

  return (
    <div className={classes.medication_wrapper}>
      <h4>Medication</h4>

      <SelectWithSearch
        label="Search"
        wrapperClassName={classes.medication_search}
        searchValue={searchValue}
        onChange={(value) => searchMedication(value)}
        options={medicationsList}
        loading={loading}
        clearValueAfterSelect
        tableOption={infoScript}
        error={error}
        optionKey=""
        onSelectOption={(option) => selectMedication('productsSelected', option)}
      />

      {!!medicationInfo.length && (
        <div className={classes.medication_content}>
          <div className={classes.chip_wrapper}>
            {medicationInfo.map((m) => (
              <Chip
                key={m.id}
                text={m.name}
                onClear={() => selectMedication('productsSelected', m)}
              />
            ))}
          </div>

          <table className={classes.table}>
            <thead>
              <tr>
                {info.map(({ name }) => (
                  <th key={name}>{name}</th>
                ))}
              </tr>
            </thead>

            <tbody id="tbody">
              {medicationInfo.map((m, index) => (
                <tr key={m.id}>
                  {!product && !adjust
                    ? info.map(({ path }) => (
                      <td key={m.id + path}>{m[path]}</td>
                    ))
                    : info.map((i) => (
                      viewInput.includes(i.path)
                        ? (
                          <td key={m.id + i.path}>
                            <InputField
                              value={i.path === 'quantity'
                                ? medicationInfo[index].data.qtyChange
                                : medicationInfo[index].data[i.path]}
                              onChange={(value) => setMedication(i.path, value, m.id)}
                              onKeyPress={(e) => onKeyPress(e, i?.validation)}
                              onPaste={(e) => onKeyPress(e, i?.validation, true)}
                              error={errors.find((e) => m.id === e.id)
                                ? errors.find((e) => m.id === e.id)[i.path]
                                : false}
                            />
                          </td>
                        )
                        : i.path === 'expiration'
                          ? (
                            <td key={m.id + i.path}>
                              <DOBPicker
                                placeholder="mm/dd/yyyy"
                                dateFormat="YYYY-MM-DD"
                                date={medicationInfo[index].data
                                  ? medicationInfo[index].data.expiration
                                  : medicationInfo[index].expiration}
                                onChange={(date) => setMedication('expiration', date, m.id)}
                                autoValidation={false}
                                error={errors.find((e) => m.id === e.id)?.expiration}
                              />
                            </td>
                          )
                          : <td key={m.id + i.path}>{m[i.path]}</td>
                    ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      )}
    </div>
  );
};

Medication.propTypes = {
  medicationInfo: PropTypes.array.isRequired,
  error: PropTypes.string,
  setMedication: PropTypes.func.isRequired,
  product: PropTypes.bool,
  adjust: PropTypes.bool,
  errors: PropTypes.array,
};

Medication.defaultProps = {
  error: '',
  errors: [],
  product: false,
  adjust: false,
};

export default Medication;
